export default __webpack_public_path__ + "static/media/tick-circle.inline.97db11fe.svg";